import React, {useEffect, useState} from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';

import {Button, Form, Tag, notification, Row, Col, message} from 'antd';

import './style.css';
import ConfirmationAction from '../../CommonComponents/PaymentConfirmationAction';
import {useNavigate, useParams} from 'react-router-dom';

import CommonTable from '../../CommonComponents/EventCommonTable';
import {
  UploadFileMaxSize,
  displayFileName,
  filterFoodOptionColumnsForAttendee,
  formatCurrency,
  formatCurrencyByLocalChapter,
  getLocalStorageUserInfo,
  scrollAndFocusFormErrorField,
  validatePaymentPrice,
} from '../../../Util/commonUtility';
import PromotionalCodeInputCart from '../../CommonComponents/CouponCodeInputCart';

import CustomCollapse from '../../CommonComponents/CommonAccordian';

import SponsorPerksCard from '../../CommonComponents/SponsorPerksComponent';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import NavigationComponent from '../../CommonComponents/CommonBackButton';
import SponsorModal from '../../CommonComponents/SponsorModal';

import SponsorDetailForm from './SponsorDetailForm';
import {applicationConfig} from '../../../Util/config';
import {useThrottle} from '../../../hooks/useThrottle';
import {useDispatch} from 'react-redux';
import CommonUserModal from '../../CommonComponents/CommonUserModal';
import {FETCH_ERROR} from './../../../Constant/ActionTypes';
import {UploadOutlined} from '@ant-design/icons';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';

const EventSponsorComponent = ({
  eventName,
  inPersonRemaining,
  eventType,
  eventISOnline,
  totalCartPrice,
  eventRegisterData,
  allSponsorAttendeesData,
  sponsorData,
  deleteAttendeeById,
  postAttendeesById,
  postSponsorAttendeesById,
  allEventOptionsFoodData,
  updateSponsorAttendee,
  SponsorAttendeeOptionById,
  sponsorPerksData,
  attendeesDataWithPerks,
  updateSponosor,
  fetchSponsorAttendeesList,
  setAttendeesData,
  setListAttendeesDataWithPerks,
  eventLocalChapterData,
  applyCouponCode,
  appliedCartCoupon,
  paymentByUserRegistration,
}) => {
  const {ApplicationString, currentLanguage} = useLocalization();
  const {id, optionId} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editingKey, setEditingKey] = useState('');
  const [form] = Form.useForm();
  const [isAddAttendee, setIsAddAttendee] = useState(false);
  const isEditing = (record) => record.id === editingKey;
  const [sponsorOption, setSelectOptionsValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [api] = notification.useNotification();
  const [eventSponsorshipOption, setEventSponsorshipOption] = useState();
  const [eventSponsorPerksData, setEventSponsorPerksData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventSponsorData, setEventSponsor] = useState([]);
  const [validBannerFileList, setValidBannerFileList] = useState([]);
  const [validLogoFileList, setValidLogoFileList] = useState([]);
  const localUserData = getLocalStorageUserInfo();
  const [isSponsorModalOpen, setIsSponsorModalOpen] = useState(false);
  const [disableAttendeeClicks, setDisableAttendeeClicks] = useState(false);
  const [disablePaymentClicks, setDisablePaymentClicks] = useState(false);

  useEffect(() => {
    if (sponsorPerksData) {
      setEventSponsorPerksData(sponsorPerksData);
    } else {
      SponsorAttendeeOptionById(optionId);
    }
  }, [sponsorPerksData, optionId]);

  useEffect(() => {
    if (Object.keys(eventSponsorData).length > 0) {
      setIsModalOpen(false);
    }
  }, [sponsorData]);

  const edit = (record) => {
    const EditData = {
      ...record,
      attendee_email_confirm: record?.attendee_email
        ? record?.attendee_email
        : '',
      food_option:
        record?.food_option === ''
          ? []
          : record.event_registration_options?.food?.event_option_id ||
            'no-food',
      registration_option:
        record.event_registration_options?.registration?.event_option_id,
    };
    if (!isAddAttendee) {
      form.setFieldsValue({
        ...EditData,
      });
    }
    setEditingKey(record.id);
  };

  const cancel = () => {
    if (isAddAttendee) {
      allSponsorAttendeesData.pop();
      setIsAddAttendee(false);
      setAttendeesData([...allSponsorAttendeesData]);
    }
    form.resetFields();
    setIsAddAttendee(false);
    setEditingKey('');
  };

  const save = async (data) => {
    let row;
    try {
      row = await form.validateFields();
    } catch (errInfo) {
      scrollAndFocusFormErrorField(errInfo, form);
      return;
    }
    const sponsorData = {
      ...row,
      event_option_perk_id: sponsorOption?.event_sponsorship_perk?.id,
      sponsorship_option_id:
        sponsorOption?.event_sponsorship_perk?.event_option_id,
      event_id: Number(id),
      food_option:
        row.food_option === 'no-food' ||
        eventType?.toLowerCase() === 'webcast' ||
        eventISOnline
          ? {}
          : {
              type: 'food',
              event_option_id: row.food_option,
              qty: 1,
            },
      registration_option: {
        type: 'registration',
        event_option_id: row.registration_option,
        qty: 1,
      },
      registration_type:
        eventType?.toLowerCase() === 'webcast' || eventISOnline
          ? 'Webcast'
          : 'In-Person',
    };

    if (isAddAttendee) {
      postAttendeesById(sponsorData, setEditingKey, form, setIsAddAttendee);
    } else {
      const EditData = {
        ...row,
        event_option_perk_id:
          eventSponsorshipOption?.event_sponsorship_perk?.id,
        sponsorship_option_id: eventSponsorshipOption?.event_option_id,
        event_id: Number(id),
        food_option:
          row?.food_option === 'no-food' ||
          eventType?.toLowerCase() === 'webcast' ||
          eventISOnline
            ? {}
            : {
                type: 'food',
                event_option_id: row?.food_option,
                qty: 1,
                id: data?.food_option?.id,
              },
        registration_option: {
          type: 'registration',
          event_option_id: row?.registration_option,
          qty: 1,
          id: data?.registration_option?.id,
        },
      };
      updateSponsorAttendee(EditData, data.id, setEditingKey, form);
    }
  };

  const handleDelete = (id) => {
    deleteAttendeeById(id);
  };

  useEffect(() => {
    const newRow = {
      id: '1',
      attendee_first_name: '',
      attendee_last_name: '',
      attendee_company: '',
      attendee_email: '',
      event_id: '',
      is_reps: '',
      event_option_type: '',
      food_option: '',
      price: '',
    };
    if (allSponsorAttendeesData && allSponsorAttendeesData?.length === 0) {
      setIsAddAttendee(true);
      edit(newRow);
      setAttendeesData([...allSponsorAttendeesData, newRow]);
    }
  }, [allSponsorAttendeesData]);

  useEffect(() => {
    const newRow = {
      id: '1',
      attendee_first_name: '',
      attendee_last_name: '',
      attendee_company: '',
      attendee_email: '',
      event_id: '',
      is_reps: '',
      event_option_type: '',
      food_option: '',
      price: '',
    };
    if (allSponsorAttendeesData?.length === 0) {
      const loading =
        !allSponsorAttendeesData || allSponsorAttendeesData.length === 0;
      setLoading(loading);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setIsAddAttendee(true);
      edit(newRow);
      setAttendeesData([...allSponsorAttendeesData, newRow]);
    }
  }, [allSponsorAttendeesData]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    const eventOptionData =
      sponsorData?.event_registration_options?.sponsorship;
    const label =
      eventOptionData?.name + '-' + formatCurrency(eventOptionData?.price);
    if (eventOptionData) {
      setEventSponsorshipOption(eventOptionData);
      setSelectOptionsValue(eventOptionData);
    }
    setEventSponsor(sponsorData);

    sponsorData?.banners?.length > 0 &&
      setValidBannerFileList([
        {
          uid: String(sponsorData?.banners[0]?.id),
          name: displayFileName(sponsorData?.banners[0]),
          status: 'done',
          url: `${applicationConfig.UPLOAD_URL}/${sponsorData?.banners[0]?.name}`,
          fileId: sponsorData?.banners[0]?.id,
        },
      ]);
    sponsorData?.logos?.length > 0 &&
      setValidLogoFileList([
        {
          uid: String(sponsorData?.logos[0]?.id),
          name: displayFileName(sponsorData?.logos[0]),
          status: 'done',
          url: `${applicationConfig.UPLOAD_URL}/${sponsorData?.logos[0]?.name}`,
          fileId: sponsorData?.logos[0]?.id,
        },
      ]);
  }, [sponsorData]);

  const columns = [
    {
      title: ApplicationString['sponsorAddComponent.table.title.name'],
      dataIndex: 'name',
      key: 'name',
      editable: true,
      width: '15%',
      render: (text, record) => {
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {record.attendee_first_name} {record.attendee_last_name}
          </Tag>
        );
      },
    },
    {
      title: ApplicationString['sponsorAddComponent.table.title.email'],
      dataIndex: 'attendee_email',
      editable: true,
      width: '18%',
      render: (text) => {
        return <Tag prefixCls='regularAttendeesTag'>{text}</Tag>;
      },
    },
    {
      title: ApplicationString['sponsorAddComponent.table.title.option'],
      dataIndex: 'option',
      key: 'registration_and_food_option',
      editable: true,
      width: '15%',
      render: (_, record) => {
        const registrationName =
          record?.event_registration_options?.registration?.name;
        const price = record?.event_registration_options?.registration?.price;
        const foodName =
          record?.event_registration_options?.food?.name || 'No Food';
        const foodPrice = record?.event_registration_options?.food?.price;
        return (
          <div className='option-tag-container'>
            <Tag prefixCls='regularAttendeesTag'>
              Registration: {registrationName} -{' '}
              {formatCurrencyByLocalChapter(price, eventLocalChapterData)}
            </Tag>
            {eventType !== 'Webcast' && (
              <Tag prefixCls='regularAttendeesTag'>
                Food: {foodName}{' '}
                {foodPrice
                  ? '- ' +
                    formatCurrencyByLocalChapter(
                      foodPrice,
                      eventLocalChapterData,
                    )
                  : ''}
              </Tag>
            )}
          </div>
        );
      },
    },

    {
      title: ApplicationString['sponsorAddComponent.table.title.company'],
      dataIndex: 'attendee_company',
      key: 'company',
      width: '15%',
      editable: true,
      render: (text) => {
        return <Tag prefixCls='regularAttendeesTag'>{text}</Tag>;
      },
    },
    {
      title: ApplicationString['sponsorAddComponent.table.title.price'],
      dataIndex: 'total_cost',
      width: '5%',
      render: (text) => {
        return (
          <h4 className='regularAttendees-price'>
            {formatCurrencyByLocalChapter(text, eventLocalChapterData)}
          </h4>
        );
      },
    },
    {
      title: ApplicationString['sponsorAddComponent.table.title.action'],
      dataIndex: 'action',
      width: '6%',
      render: (_, record) => {
        return (
          <AdminActionsDropdown
            record={record}
            usedForAttendeeTable={true}
            editBool={true}
            attendeeEditingKey={editingKey}
            handleCancelClick={cancel}
            handleSaveClick={save}
            deleteBool={true}
            handleEditClick={edit}
            handleDeleteClick={() => handleDelete(record.id)}
            isAddAttendee={isAddAttendee}
          />
        );
      },
    },
  ];

  const onConfirm = useThrottle(() => {
    if (Object.keys(sponsorData)?.length <= 0 || disablePaymentClicks) {
      dispatch({
        type: FETCH_ERROR,
        payload: ApplicationString['sponsorAddComponent.errorMessage'],
      });
      return;
    }
    if (validatePaymentPrice(totalCartPrice?.discounted_price, dispatch)) {
      return;
    }
    const attendeeSponsorType = eventSponsorPerksData?.sponsorship_type;
    paymentByUserRegistration(id, optionId, attendeeSponsorType);
  }, 2000);

  const handleConfirmModalCancel = () => {
    setIsSponsorModalOpen(false);
  };

  const handleCancel = () => {
    navigate(`/eventDetails/${id}`);
  };

  const showModal = () => {
    if (Object.keys(sponsorData)?.length <= 0) {
      message.warning(ApplicationString['sponsorAddComponent.errorMessage']);
      return;
    }
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const uploadLogoFormats = ['image/png', 'image/jpeg', 'image/jpg'];
  const uploadBannerFormats = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/jpg',
  ];

  const beforeUploadLogos = {
    name: 'file',
    multiple: true,
    maxCount: 10,
    // listType: 'picture',
    beforeUpload: (file) => {
      const isRightFormat = uploadLogoFormats.includes(file.type);
      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: ApplicationString['sponsorAddComponent.fileFormatError'],
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload:
            ApplicationString['sponsorAddComponent.fileSizeError'](
              UploadFileMaxSize,
            ),
        });
        return false;
      }
      if (file?.type?.includes('image')) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = () => {
            if (img.width >= 200 && img.height >= 200) {
              setValidLogoFileList((prev) => [file]);
              resolve(isRightFormat && isLt2M);
            } else {
              dispatch({
                type: FETCH_ERROR,
                payload:
                  ApplicationString['sponsorAddComponent.imageSizeError'],
              });
              setValidLogoFileList((prev) =>
                prev.filter((f) => f.uid !== file.uid),
              );
              reject();
            }
          };
          img.onerror = reject;
        });
      } else {
        setValidLogoFileList((prev) => [file]);
        return isRightFormat && isLt2M;
      }
    },
  };

  const beforeUploadBanner = {
    name: 'file2',
    multiple: true,
    maxCount: 10,
    // listType: 'picture',
    beforeUpload: (file) => {
      const isRightFormat = uploadBannerFormats.includes(file.type);
      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: ApplicationString['sponsorAddComponent.fileFormatError'],
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload:
            ApplicationString['sponsorAddComponent.fileSizeError'](
              UploadFileMaxSize,
            ),
        });
        return false;
      }
      if (file?.type?.includes('image')) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = () => {
            if (img.width >= 200 && img.height >= 200) {
              setValidBannerFileList((prev) => [file]);
              resolve(isRightFormat && isLt2M);
            } else {
              dispatch({
                type: FETCH_ERROR,
                payload:
                  ApplicationString['sponsorAddComponent.imageSizeError'],
              });
              setValidBannerFileList((prev) =>
                prev.filter((f) => f.uid !== file.uid),
              );
              reject();
            }
          };
          img.onerror = reject;
        });
      } else {
        setValidBannerFileList((prev) => [file]);
        return isRightFormat && isLt2M;
      }
    },
  };

  const removeBannerFileHandler = (file) => {
    setValidBannerFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  const removeLogoFileHandler = (file) => {
    setValidLogoFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  const dummyRequest = ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onFinishSponsor = (
    values,
    setSponsorCreatedSuccessFully,
    setEditDetails,
  ) => {
    const eventOptionID =
      eventSponsorPerksData?.eventSponsorshipPerk?.event_option_id;
    const SponsorData =
      Object.keys(eventSponsorData).length > 0
        ? {
            ...values,
            event_id: id,
          }
        : {
            ...values,
            sponsorship_option_id: eventOptionID,
            event_id: id,
          };

    const formData = new FormData();
    Object.entries(SponsorData).forEach(([key, value]) => {
      // logo/flyer Form.Item names are swapped vs assets; append from file lists below.
      if (key === 'logo' || key === 'flyer') {
        return;
      }
      if (key === 'sponsorship_option') {
        const new_value = JSON.stringify(value);
        formData.append(key, value ? new_value : '');
      } else {
        formData.append(key, value ? value : '');
      }
    });

    const existingLogoId = sponsorData?.logos?.[0]?.id;
    const logoFile = validLogoFileList[0];
    if (logoFile?.originFileObj || (logoFile && logoFile instanceof File)) {
      formData.append('logos', logoFile.originFileObj || logoFile);
    } else if (
      existingLogoId &&
      logoFile &&
      String(logoFile.uid) === String(existingLogoId)
    ) {
      formData.append('logo_ids', `[${existingLogoId}]`);
    } else if (existingLogoId && !logoFile) {
      formData.append('logo_ids', `[${existingLogoId}]`);
    }

    const existingBannerId = sponsorData?.banners?.[0]?.id;
    const bannerFile = validBannerFileList[0];
    if (
      bannerFile?.originFileObj ||
      (bannerFile && bannerFile instanceof File)
    ) {
      formData.append('banners', bannerFile.originFileObj || bannerFile);
    } else if (
      existingBannerId &&
      bannerFile &&
      String(bannerFile.uid) === String(existingBannerId)
    ) {
      formData.append('banner_ids', `[${existingBannerId}]`);
    } else if (existingBannerId && !bannerFile) {
      formData.append('banner_ids', `[${existingBannerId}]`);
    }
    if (Object.keys(eventSponsorData).length > 0) {
      updateSponosor(formData, values?.id, setEditDetails);
    } else {
      postSponsorAttendeesById(
        formData,
        setSponsorCreatedSuccessFully,
        setEditDetails,
      );
    }
    handleClose();
  };

  const mergedColumns = filterFoodOptionColumnsForAttendee(
    columns,
    eventType,
    isEditing,
  );

  return (
    <React.Fragment>
      <SponsorModal
        eventSponsorPerksData={eventSponsorPerksData}
        handleClose={handleClose}
        eventSponsorData={eventSponsorData}
        isModalOpen={isModalOpen}
        onFinish={onFinishSponsor}
        localUserData={localUserData}
        removeLogoFileHandler={removeLogoFileHandler}
        removeBannerFileHandler={removeBannerFileHandler}
        dummyRequest={dummyRequest}
        validLogoFileList={validLogoFileList}
        validBannerFileList={validBannerFileList}
        beforeUploadLogos={beforeUploadLogos}
        beforeUploadBanner={beforeUploadBanner}
        fetchSponsorAttendeesList={(id) => {
          fetchSponsorAttendeesList(id);
        }}
      />
      <Row gutter={[0, 10]} className='pbssMainContainerRow'>
        <div className='stickyEventName'>
          <SponsorOptionPageHeroText
            title={eventName}
            subTitle={ApplicationString['userEventSponsorComponent.subheading']}
          />
        </div>
        <Col span={24}>
          <SectionLayout>
            <div className='hero-subheading'>
              {ApplicationString['sponsorAddComponent.contactUs']}{' '}
              <a href='mailto:info@pbss.org'>
                {ApplicationString['sponsorAddComponent.contactUs.link']}
              </a>{' '}
              {ApplicationString['userAddAttendeeComponent.message']}
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div className='addAttendees-button-wrapper'>
              <NavigationComponent
                name={
                  ApplicationString[
                    'userEventSponsorComponent.backtoSponsorOption'
                  ]
                }
                urlPath={`sponsorshipOption/${id}`}
              />
              <Button
                onClick={() => {
                  navigate(`/addAttendees/${id}`);
                }}
                className='reg-navigation-btn'>
                {
                  ApplicationString[
                    'userEventSponsorComponent.registerAs.regularAttendeeText'
                  ]
                }
              </Button>
              <Button
                onClick={() => {
                  navigate(`/myEvents`);
                }}
                className='reg-navigation-btn'>
                {
                  ApplicationString[
                    'userEventSponsorComponent.registerAs.myEvents'
                  ]
                }
              </Button>
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <SponsorPerksCard
              hideButton
              multiple={false}
              hideUpload={eventSponsorPerksData?.sponsorship_type == '3'}
              handleClickUpload={showModal}
              handleCloseUpload={handleClose}
              upload
              title={eventSponsorPerksData?.name}
              sponsorshipType={eventSponsorPerksData?.sponsorship_type}
              spot={
                eventSponsorPerksData?.qty - eventSponsorPerksData?.used_qty > 0
                  ? eventSponsorPerksData?.qty - eventSponsorPerksData?.used_qty
                  : null
              }
              totalSpot={
                eventSponsorPerksData?.qty >= 0 ? eventSponsorPerksData?.qty : 0
              }
              price={eventSponsorPerksData?.price}
              perks={eventSponsorPerksData?.eventSponsorshipPerk}
              id={eventSponsorPerksData?.id}
              eventId={eventSponsorPerksData?.event_id}
              optionId={optionId}
              attendeeDataOptionId={
                eventSponsorData?.event_registration_options?.sponsorship
                  ?.event_sponsorship_perk?.event_option_id
              }
              eventLocalChapterData={eventLocalChapterData}
            />
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <SponsorDetailForm
              alertInformation={
                eventSponsorPerksData?.eventSponsorshipPerk
                  ?.sponsor_contact_content
              }
              eventSponsorData={eventSponsorData}
              onFinish={onFinishSponsor}
              localUserData={localUserData}
              setDisableAttendeeClicks={setDisableAttendeeClicks}
              eventType={eventType}
            />
          </SectionLayout>
        </Col>
        {eventSponsorPerksData?.sponsorship_type == '3' ? (
          <Col span={24}>
            <SectionLayout uploadButtonStyle>
              <button
                onClick={showModal}
                className='reg-navigation-btn upload-height upload-logo-success'>
                <UploadOutlined />{' '}
                {
                  ApplicationString[
                    'userEventSponsorComponent.sponsorPerks.uploadLogo'
                  ]
                }
              </button>
            </SectionLayout>
          </Col>
        ) : (
          ''
        )}
        <Col span={24}>
          <CommonTable
            alertInformation={
              eventSponsorPerksData?.eventSponsorshipPerk?.sponsor_perk_content
            }
            attendeesDataWithPerks={attendeesDataWithPerks}
            allEventOptionsFoodData={allEventOptionsFoodData}
            sponsorOption={sponsorOption}
            onSave={(
              Data,
              setEditingKey,
              form,
              setIsAddAttendee,
              setDisableAttendeeClicks,
              setDisablePaymentClicks,
              setDisableEditClicks,
              setIsSavingAttendee,
            ) => {
              postAttendeesById(
                Data,
                setEditingKey,
                form,
                setIsAddAttendee,
                setDisableAttendeeClicks,
                setDisablePaymentClicks,
                setDisableEditClicks,
                setIsSavingAttendee,
              );
            }}
            onEdit={(
              id,
              Data,
              setEditingKey,
              form,
              setDisableAttendeeClicks,
              setDisablePaymentClicks,
              setDisableEditClicks,
              setIsSavingAttendee,
            ) => {
              updateSponsorAttendee(
                id,
                Data,
                setEditingKey,
                form,
                setDisableAttendeeClicks,
                setDisablePaymentClicks,
                setDisableEditClicks,
                setIsSavingAttendee,
              );
            }}
            onDelete={handleDelete}
            sponsorPerksData={eventSponsorPerksData}
            eventType={eventType}
            setListAttendeesDataWithPerks={setListAttendeesDataWithPerks}
            setDisablePaymentClicks={setDisablePaymentClicks}
            disablePaymentClicks={disablePaymentClicks}
            eventLocalChapterData={eventLocalChapterData}
            eventISOnline={eventISOnline}
            inPersonRemaining={inPersonRemaining}
          />
        </Col>
        {Object.keys(sponsorData || {}).length > 0 && (
          <Col span={24}>
            <SectionLayout>
              <div className='attendees-payment-section'>
                <div className='attendees-cart-coupon-container'>
                  <PromotionalCodeInputCart
                    title={
                      ApplicationString[
                        'userAttendeeCartComponent.couponCodeTitle'
                      ]
                    }
                    buttonText={
                      ApplicationString[
                        'userAttendeeCartComponent.couponCodeButtonText'
                      ]
                    }
                    onRedeemClick={(Data) => {
                      applyCouponCode({
                        ...Data,
                        eventId: parseInt(id),
                        is_sponsor: true,
                      });
                    }}
                    appliedCartCoupon={appliedCartCoupon}
                  />
                </div>
                <ConfirmationAction
                  heading={
                    ApplicationString[
                      'userAttendeeCartComponent.totalAmountToBePaid'
                    ]
                  }
                  data={eventRegisterData?.attendees}
                  submitName={
                    ApplicationString['userEventSponsorComponent.ProceedToPay']
                  }
                  onConfirm={onConfirm}
                  onCancel={handleCancel}
                  totalCartPrice={totalCartPrice}
                  usedForSponsor
                  usedForCart
                  disable={disableAttendeeClicks || disablePaymentClicks}
                  extra={ApplicationString['sponsor-cart-screen-extra-message']}
                  eventLocalChapterData={eventLocalChapterData}
                />
              </div>
            </SectionLayout>
          </Col>
        )}
        {currentLanguage !== LANGUAGES.JA && (
          <Col span={24}>
            <SectionLayout>
              <CustomCollapse />
            </SectionLayout>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default EventSponsorComponent;
